import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import AuthRoute from "./components/AuthRoute";
import PageNotFound from "./pages/PageNotFound";
import DashboardControl from "./pages/DashboardControl";
import DashboardTeam from "./pages/DashboardTeam";
import Login from "./pages/Login";
import ApolloClient from "./apolloSetup";
import AddPlayer from "./pages/AddPlayer";
import MatchLive from "./pages/MatchLive";
import StoryMatch from "./pages/StoryMatch";
import Player from "./pages/Player";
import Terms from "./pages/Terms";
import FreePlayers from "./pages/FreePlayers";
import TableTeamPlayers from "./pages/TableTeamPlayers";

ReactDOM.render(
  <ApolloProvider client={ApolloClient}>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Dashboard />} />
        <Route exact path="/admin" element={<Login />} />
        <Route exact path="/player/:name" element={<Player />} />
        <Route exact path="/terms" element={<Terms />} />
        <Route
          exact
          path="/admin/control"
          element={<AuthRoute>{<DashboardControl />}</AuthRoute>}
        />
        <Route
          exact
          path="/admin/livematch"
          element={<AuthRoute>{<MatchLive />}</AuthRoute>}
        />
        <Route
          exact
          path="/team/:name"
          element={<AuthRoute>{<DashboardTeam />}</AuthRoute>}
        />
        <Route
          exact
          path="/admin/addplayer"
          element={<AuthRoute>{<AddPlayer />}</AuthRoute>}
        />
        <Route
          exact
          path="/storymatch"
          element={<AuthRoute>{<StoryMatch />}</AuthRoute>}
        />
        <Route
          exact
          path="/freeplayers"
          element={<AuthRoute>{<FreePlayers />}</AuthRoute>}
        />
        <Route
          exact
          path="/team/players"
          element={<AuthRoute>{<TableTeamPlayers />}</AuthRoute>}
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);

reportWebVitals();
